import { render, staticRenderFns } from "./VeHrJiatingList.vue?vue&type=template&id=2ccbc060&scoped=true"
import script from "./VeHrJiatingList.vue?vue&type=script&lang=js"
export * from "./VeHrJiatingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccbc060",
  null
  
)

export default component.exports